import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { Link } from '../../text';

export const TopLinks = ({ topLinks, handleLinkPress, isMobile }) => {
    if (!topLinks) {
        return null;
    }

    return (
        <View style={isMobile ? Styles.containerMobile : Styles.container}>
            {Object.values(topLinks).map(topLink => (
                <Link key={topLink.id} onPress={() => handleLinkPress(topLink.link, topLink.linkText)} style={Styles.text} text={topLink.linkText} />
            ))}
        </View>
    );
};

const Styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'flex-start'
    },
    containerMobile: {
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        marginVertical: 10
    },
    text: {
        color: '#153d6e',
        fontFamily: 'GothamBook',
        fontSize: Platform.OS.equals('web') ? '14pt' : 14,
        lineHeight: Platform.OS.equals('web') ? '16pt' : 16,
        marginHorizontal: 8,
        textDecorationLine: 'none'
    }
});
